"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overflowsY = exports.overflowsX = void 0;

var _BrowserTest = require("./BrowserTest");

var overflowsX = function overflowsX(innerEl) {
  var outerEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : innerEl;
  var tolerance = (0, _BrowserTest.isMS)() ? 1 : 0; // IE/Edge rounding workaround; see HubSpot/UIComponents#1711

  var contentWidth = innerEl.scrollWidth;
  var containerWidth = outerEl.clientWidth;
  return contentWidth > containerWidth + tolerance;
};

exports.overflowsX = overflowsX;

var overflowsY = function overflowsY(innerEl) {
  var outerEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : innerEl;
  var tolerance = (0, _BrowserTest.isMS)() ? 1 : 0; // IE/Edge rounding workaround; see HubSpot/UIComponents#1711

  var contentHeight = innerEl.scrollHeight;
  var containerHeight = outerEl.clientHeight;
  return contentHeight > containerHeight + tolerance;
};

exports.overflowsY = overflowsY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/Overflows.js
// module id = 707
// module chunks = 209 210 211 212